<script setup lang="ts">
import NitCloseButton from '@/atoms/NitCloseButton.vue'
import NitModal from '@/components/Modal/NitModal.vue'
import { isNotNil } from '@/helpers/lodash-ext'
interface Props {
  title?: string
  showCloseButton?: boolean
  maxWidth?: string
  minWidth?: string
  fullModalSp?: boolean
}
const props = withDefaults(defineProps<Props>(), {
  showCloseButton: true,
  maxWidth: '560px',
  fullModalSp: false
})
const { title } = toRefs(props)
defineEmits<{
  (e: 'close'): void
}>()

const slots = useSlots()
const hasFirstButtonSlot = computed((): boolean => {
  return isNotNil(slots['first-button'])
})
const hasSecondButtonSlot = computed((): boolean => {
  return isNotNil(slots['second-button'])
})

const hasButton = computed((): boolean => {
  return hasFirstButtonSlot.value || hasSecondButtonSlot.value
})

const hasTitle = computed((): boolean => {
  return isNotNil(slots['title']) || isNotNil(title.value)
})

const hasDescription = computed((): boolean => {
  return isNotNil(slots['description'])
})
</script>
<template>
  <!-- 一旦レスポンシブで頑張ってる状態。しんどくなったら分けてOK -->
  <NitModal @blur="$emit('close')">
    <div
      class="modal-with-buttons position-relative modal-margin"
      :class="{
        'modal-with-buttons--full-sp': fullModalSp
      }"
      :style="{ 'max-width': maxWidth, 'min-width': minWidth }"
    >
      <NitCloseButton v-if="showCloseButton" @close="() => $emit('close')" />
      <div
        class="modal-with-buttons__content modal-content-section lo-v-center"
        :class="{
          'no-button-section': !hasButton
        }"
      >
        <main-title
          v-if="hasTitle"
          class="title"
          :style="{ 'margin-bottom': '12px' }"
        >
          <slot name="title" />
          <p>{{ title }}</p>
        </main-title>
        <description
          v-if="hasDescription"
          class="description gray-1"
          :style="{ 'margin-bottom': '24px' }"
        >
          <slot name="description" />
        </description>
        <div class="contents fill-wt lo-v-center">
          <slot name="contents" />
        </div>
      </div>
      <div
        v-if="hasButton"
        class="modal-with-buttons__button-section modal-button-section"
      >
        <div v-if="hasSecondButtonSlot" class="lo-h-inline-flex-start fill-wt">
          <div class="modal-with-buttons__second-button">
            <slot name="second-button" />
          </div>
          <div class="modal-with-buttons__first-button mg-left-12px">
            <slot name="first-button" />
          </div>
        </div>
        <div v-else class="lo-v-center fill-wt">
          <slot name="first-button" />
        </div>
      </div>
    </div>
  </NitModal>
</template>

<style scoped>
.modal-with-buttons {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: calc(100dvh - var(--base-40px) * 2);
  overflow: hidden;
}

.modal-with-buttons__content {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
}

.modal-with-buttons__button-section {
  flex: 0 0 auto;
}

.modal-with-buttons__second-button,
.modal-with-buttons__first-button {
  width: 100%;
}

@media screen and (max-height: 600px) {
  .modal-with-buttons {
    max-height: 100dvh;
  }
}

@media screen and (max-width: 800px) {
  .modal-with-buttons {
    width: calc(100vw - var(--base-8px) * 2);
    max-height: calc(100dvh - var(--base-8px) * 2);
  }

  .modal-with-buttons--full-sp {
    width: 100vw;
    height: 100dvh;
    max-width: none !important;
    max-height: 100dvh;
    margin: 0;
  }

  .modal-with-buttons--full-sp .modal-content-section {
    width: 100%;
  }
}
</style>
